export default "/hotbox/content/frontend/release/static/misc/search_plugin.xml";